import {
  PROJECT,
  SET_DROP_DOWN_VALUES,
  SET_REDMINE_FIELDS,
  FETCH_DROP_DOWN_VALUES,
  RETRIEVE_PROJECT,
  SET_REDMINE_DEFAULT_VALUES,
  DROP_DOWN_VALUES_RETRIEVED,
  SET_PROJECT,
  SET_TEAM_MEMBER_LIST,
  VENDOR_NAME_TO_ID_MAP,
  VENDOR_ID_TO_NAME_MAP,
  TEAM_MEMBER_ID_TO_NAME_MAP,
  TEAM_LEADER_EMAIL_MAP,
  GET_SHAREPOINT_FOLDER_ID,
  SHAREPOINT_FOLDER_ID,
  GET_WORKFLOW,
  WORKFLOW,
  WORKFLOW_PERMISSION,
  SEARCH_CRITERIA,
  SAVE_SEARCH_CRITERIA,
  REDMINE_ROLE_ID,
  CUSTOM_FIELD_VISIBILITIES,
  GET_VENDOR_LIST,
  IS_VENDOR,
  VENDOR_LIST
} from './definition'
import {
  USER
} from 'src/store/definition'
import {
  getProjects,
  getCustomFields,
  getTrackers,
  getStatuses,
  getPriorities
} from 'src/services/redmine/index'
import {
  getTeamMembers,
  getVendors,
  getTeamLeader,
  getSharepointFolderId,
  getRedmineRoleId,
  getWorkflow,
  getWorkflowPermission,
  getVendorHierarchy
} from '../service'
import {
  updateSearchPanelUserPreferences
} from 'src/components/common/service'

const listToObject = function (list) {
  return list.reduce((obj, item) => {
    if (item.isDefault) {
      obj.defaultValue = item.id
    }
    obj.list.push(item)
    return obj
  }, {
    list: [],
    defaultValue: null
  })
}

export default {
  [FETCH_DROP_DOWN_VALUES] ({ getters, commit }) {
    if (!getters[DROP_DOWN_VALUES_RETRIEVED]) {
      const user = getters[USER]
      let { token, accessGroupList } = user

      return new Promise((resolve, reject) => {
        let mstAccessGroup = accessGroupList.find(accessGroup => accessGroup.accessGroup.indexOf('SERVICE_REQUEST_') !== -1)
        if (!mstAccessGroup) {
          reject()
          return
        }
        Promise.all([
          getCustomFields(token),
          getTrackers(token),
          getStatuses(token),
          getPriorities(token),
          getTeamMembers(),
          getVendors(token),
          getTeamLeader(),
          getRedmineRoleId({
            token,
            accessGroupId: mstAccessGroup.accessGroupSid
          })
        ]).then(dataSet => {
          let [
            customFieldsResult,
            trackers,
            statuses,
            priorities,
            teamMembers,
            vendors,
            teamLeaders,
            roleId
          ] = [...dataSet]
          let { customFields, rawCustomFields } = customFieldsResult
          let customFieldVisibilities = rawCustomFields.filter(customField => {
            return customField.roles.length === 0 || customField.roles.some(role => {
              return role.id === roleId
            })
          }).reduce((map, customField) => {
            map[customField.name] = true
            return map
          }, {})
          commit(CUSTOM_FIELD_VISIBILITIES, customFieldVisibilities)

          let customFieldMap = customFields.reduce((map, customField) => {
            map[customField.name] = customField
            return map
          }, {})
          statuses = statuses.filter(status => {
            return status.name !== 'Closed'
          })
          let dropDownValues = {
            ...customFieldMap,
            ...{
              tracker: listToObject(trackers),
              status: listToObject(statuses),
              priority: listToObject(priorities)
            }
          }
          let redmineFields = {...customFieldMap}
          commit(SET_DROP_DOWN_VALUES, dropDownValues)
          commit(SET_REDMINE_FIELDS, redmineFields)
          commit(SET_REDMINE_DEFAULT_VALUES, dropDownValues)
          commit(DROP_DOWN_VALUES_RETRIEVED)
          commit(SET_TEAM_MEMBER_LIST, teamMembers)
          let vendorNameToIdMap = vendors.reduce((map, vendor) => {
            let vendorName = vendor.firstName + ' ' + vendor.lastName
            map[vendorName.toLowerCase()] = vendor.id
            return map
          }, {})
          let vendorIdToNameMap = vendors.reduce((map, vendor) => {
            map[String(vendor.id)] = vendor.firstName + ' ' + vendor.lastName
            return map
          }, {})
          let teamMemberIdToNameMap = [...teamMembers, ...teamLeaders].reduce((map, teamMember) => {
            map[String(teamMember.id)] = teamMember.firstName + ' ' + teamMember.lastName
            return map
          }, {})
          commit(TEAM_LEADER_EMAIL_MAP, teamLeaders)
          commit(VENDOR_NAME_TO_ID_MAP, vendorNameToIdMap)
          commit(VENDOR_ID_TO_NAME_MAP, vendorIdToNameMap)
          commit(TEAM_MEMBER_ID_TO_NAME_MAP, teamMemberIdToNameMap)
          resolve()
        }).catch(() => {
          reject()
        })
      })
    }
  },
  [RETRIEVE_PROJECT] ({ getters, commit }) {
    if (!getters[PROJECT]) {
      const token = getters[USER].token
      return getProjects(token).then(projects => {
        let projectServiceRequest = projects.find(project => project['identifier'] && project['identifier'] === 'wip-mst')
        commit(SET_PROJECT, projectServiceRequest)
      })
    }
  },
  [GET_SHAREPOINT_FOLDER_ID] ({ getters, commit }) {
    if (!getters[SHAREPOINT_FOLDER_ID]) {
      let token = getters[USER].token
      return getSharepointFolderId({ token }).then(({ folderId }) => {
        commit(SHAREPOINT_FOLDER_ID, folderId)
      })
    }
  },
  [GET_WORKFLOW] ({ getters, commit }) {
    if (!getters[WORKFLOW] || !getters[WORKFLOW_PERMISSION]) {
      const user = getters[USER]
      let { token, accessGroupList } = user
      return new Promise((resolve, reject) => {
        let mstAccessGroup = accessGroupList.find(accessGroup => accessGroup.accessGroup.indexOf('SERVICE_REQUEST_') !== -1)
        if (!mstAccessGroup) {
          reject()
          return
        }
        getRedmineRoleId({
          token,
          accessGroupId: mstAccessGroup.accessGroupSid
        }).then(roleId => {
          commit(REDMINE_ROLE_ID, roleId)
          Promise.all([
            getWorkflow({
              trackerId: 1,
              roleId,
              token
            }),
            getWorkflowPermission({
              trackerId: 1,
              roleId,
              token
            })
          ]).then(responses => {
            commit(WORKFLOW, responses[0])
            commit(WORKFLOW_PERMISSION, responses[1])
            resolve()
          }).catch(() => {
            reject()
          })
        }).catch(() => {
          reject()
        })
      })
    }
  },
  [SAVE_SEARCH_CRITERIA] ({ getters, commit }, { searchCriteria, userSid, searchPanelCode }) {
    const token = getters[USER].token
    commit(SEARCH_CRITERIA, searchCriteria)
    updateSearchPanelUserPreferences({
      token,
      userSid,
      searchPanelCode,
      userPreferenceJSON: searchCriteria
    })
  },
  [GET_VENDOR_LIST] ({ getters, commit }) {
    const vendorList = getters[VENDOR_LIST]
    console.log(getters[IS_VENDOR])
    console.log(vendorList)
    if (getters[IS_VENDOR] && (!vendorList || vendorList.length === 0)) {
      const user = getters[USER]
      return getVendorHierarchy({
        token: user.token,
        vendorProfileIds: user.vendorList.map(vendor => vendor.vendorCode)
      }).then(result => {
        const vendorList = result.resource.childVendors
        commit(VENDOR_LIST, vendorList)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/sourcing_workflow/service_request/store/actions.js